export type {
  ChlupState,
  IChannelsUI,
  ChlupStateActions,
  // [WAT-11771] Exported so callers holding the selection can type it as the shape the
  // grid filter actually reads, instead of the bare `Choice` that drops `uuid` silently.
  SearchChoice
} from "./chlupStore";
export {
  // [WAT-11911] The tab-label -> view resolver. Exported so a test double for this store
  // resolves views with the real rule instead of a copy that drifts away from it.
  getComponentView,
  getDisplayedEdspBannerCategories,
  getSearchChoices,
  getSvodSearchChoices,
  initializeChlupStore,
  chlupStoreReducer
} from "./chlupStore";

export {
  channelMatchesSearchChoice,
  queryChannels,
  filterCategoricalChannels,
  orderCategoriesExact,
  orderCategoriesSubarray,
  // [WAT-11779 · WAT-11766] Keeps a selected choice pointing at the current market's row across a ZIP change.
  reconcileSearchSelections
} from "./filterMethods"
